import api from '@/api/producer';

export default {
    namespaced: true,
    state: {
        all: [],
    },

    getters: {},

    actions: {
        index ({commit}, query) {
            api.index(query).then(({data}) => {
                commit('INDEX', data);
            });
        },
        read ({commit}, id) {
            api.read(id).then(({data}) => {
                commit('READ', data);
            });
        },
        create ({commit}, formData) {
            api.create(formData).then(({data}) => {
                commit('READ', data);
            });
        },
        update ({commit}, formData) {
            api.update(formData).then(({data}) => {
                commit('READ', data);
            });
        },
        delete ({commit}, id) {
            api.delete(id).then(() => {
                commit('DELETE', id);
            });
        },

    },

    mutations: {
        INDEX (state, responseData) {
            state.all = responseData;
        },
        READ (state, responseData) {

            const idx = state.all.findIndex(a => a.id == responseData.id);

            if (idx >= 0) {

                state.all.splice(idx, 1, responseData);
            } else {

                state.all.push(responseData);
            }
        },
        DELETE (state, id) {
            const idx = state.all.findIndex(a => a.id == id);
            if (!idx >= 0) {
                state.all.splice(idx, 1);
            }
        },

    }

};
